export default {
  data () {
    return {
      isFetched: false
    }
  },
  methods: {
    $_fetch () {
      if (!this.dataId ||
        typeof this.fetchOne !== 'function' ||
        typeof this.afterFetch !== 'function') {
        return
      }
      this.loading = true
      this.fetchOne(this.dataId).then(res => {
        this.formData = res.data
        this.oriData = JSON.parse(JSON.stringify(this.formData))
        if (this.$_initTrans) {
          this.$_initTrans()
        }
        this.afterFetch()
        this.isFetched = true
      }).catch(err => {
        console.log(err)
      }).then(() => {
        this.loading = false
      })
    },
    $_alert (invalidFields) {
      let msg = ''
      Object.keys(invalidFields).map((key, i) => {
        var v = invalidFields[key]
        if (typeof v[0].message !== 'undefined') {
          msg += v[0].message + '<br/>'
        }
      })
      this.$alert(msg, this.$t('api.notValidForm'), {
        dangerouslyUseHTMLString: true,
        type: 'warning'
      })
    }
  }
}
